import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GetTranslationsWithDateResponse } from '../../../model';
import { ApplicationSelectorState, SetTranslations, TranslationEditorState } from '../../../core/state';
import { TranslationEditorService } from '../../../core/service';

export const TranslationEditorResolver: ResolveFn<GetTranslationsWithDateResponse> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<GetTranslationsWithDateResponse> | Promise<GetTranslationsWithDateResponse> | GetTranslationsWithDateResponse => {
  const translationEditorService = inject(TranslationEditorService);
  const store = inject(Store);

  console.log(store.selectSnapshot(ApplicationSelectorState.applicationSelectorFormValues))

  const { application, environment } = store.selectSnapshot(ApplicationSelectorState.applicationSelectorFormValues);
  const languages = store.selectSnapshot(TranslationEditorState.displayingLanguages);
  if (application) {
    return translationEditorService.getTranslationsWithDate(application, environment, languages).pipe(
      tap((response: GetTranslationsWithDateResponse) => {
        store.dispatch(new SetTranslations(response));
      }),
      catchError(err => {
        return throwError(() => err);
      })
    );
  }

  return of(null)
};
